import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const SUPPORTED_LANGS = ['de', 'en'] as const;
type Lang = (typeof SUPPORTED_LANGS)[number];

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation('common');
  const current = SUPPORTED_LANGS.includes(i18n.language as Lang) ? i18n.language : 'de';

  const handleChange = (_: React.MouseEvent<HTMLElement>, lang: Lang | null) => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  return (
    <ToggleButtonGroup
      value={current}
      exclusive
      onChange={handleChange}
      aria-label={t('language.switchTo')}
      size="small"
      sx={{ '& .MuiToggleButton-root': { py: 0.25, px: 1.5 } }}
    >
      {SUPPORTED_LANGS.map((lang) => (
        <ToggleButton key={lang} value={lang} aria-label={t(`language.${lang}`)}>
          {t(`language.${lang}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default LanguageSwitcher;
